<!-- TODO: add 'show stops' behavior for transit legs on double tap. Extend current labels for legs for WCAG -->
<span class="sr-only" aria-live="polite" aria-atomic="true">{{ liveAnnouncement }}</span>
<div
    class="bg-[#F0F0F0] pb-4 pt-4 shadow-t-md-inset native-app:pb-28 dark:bg-contrast-black"
    *ngIf="updatedLegs?.length > 0">
    <div
        class="pl-4 pr-4"
        *ngFor="let leg of updatedLegs ?? []; let last = last; let i = index"
        [ngClass]="{
            'relative z-10 bg-white shadow-y-md': leg.tripId || leg.mode === legMode.Flexible,
            'pb-2': i === 0,
            'pt-2': last
        }"
        [attr.aria-label]="legAriaLabels[i]"
        [attr.role]="canToggleStopsViaA11y(leg) ? 'button' : 'group'"
        [attr.aria-expanded]="canToggleStopsViaA11y(leg) ? isStopsIncludedInAria(i) : null"
        (click)="onLegA11yActivate($event, i, leg)"
        (keydown.enter)="onLegA11yActivate($event, i, leg)"
        (keydown.space)="onLegA11yActivate($event, i, leg)"
        tabindex="0">
        <rwidget-leg-origin
            *ngIf="i === 0 && isStopBusOrigin"
            [legName]="
                !search?.origin?.useLocationFromMap && !search?.origin?.useCurrentLocation && search?.origin?.name
            "
            [time]="updatedLegs[0].startTime"
            [itinerary]="itinerary"
            [delay]="
                isRealtime ||
                env.JOURNEY_PLANNER?.SCHEDULE_TIME_THRESHOLD_EARLY ||
                env.JOURNEY_PLANNER?.SCHEDULE_TIME_THRESHOLD_LATE
                    ? itinerary.journeyStartDepartureDelay
                    : 0
            "
            aria-hidden="true"></rwidget-leg-origin>

        <rwidget-leg-walk
            *ngIf="leg.mode === legMode.Walk"
            [leg]="leg"
            [isDestination]="!!last"
            aria-hidden="true"></rwidget-leg-walk>

        <rwidget-leg-wait *ngIf="leg.mode === legMode.Wait" [leg]="leg" aria-hidden="true"></rwidget-leg-wait>

        <rwidget-leg-trip
            *ngIf="leg.tripId || leg.mode === legMode.Flexible"
            [leg]="leg"
            [originalLeg]="legs[i]"
            [tripSteps]="legTripIdToDetailsMap.get(leg.tripId)"
            [expandedByA11y]="isStopsIncludedInAria(i)"
            aria-hidden="true"></rwidget-leg-trip>

        <rwidget-leg-destination
            *ngIf="last && isStopBusDestination"
            [legName]="
                !search?.destination?.useLocationFromMap &&
                !search?.destination?.useCurrentLocation &&
                search?.destination?.name
            "
            [time]="itinerary.endTime"
            [delay]="
                isRealtime ||
                env.JOURNEY_PLANNER?.SCHEDULE_TIME_THRESHOLD_EARLY ||
                env.JOURNEY_PLANNER?.SCHEDULE_TIME_THRESHOLD_LATE
                    ? itinerary.journeyEndArrivalDelay
                    : 0
            "
            aria-hidden="true"></rwidget-leg-destination>
    </div>
</div>
